import { PacingType } from "@/common/program/types";
import IconDescription from "@/components/IconDescription";

type PacingTranslate = (
  key:
    | "selfPaced"
    | "instructorLed"
    | "progressAtYourOwnSpeed"
    | "assignmentsHaveDueDates",
) => string;

export function getProgramPacingTypeIcon(
  pacingType: string,
  t: PacingTranslate,
) {
  switch (pacingType) {
    case PacingType.SELFPACED:
      return (
        <IconDescription
          iconType="person"
          title={t("selfPaced")}
          subtitle={t("progressAtYourOwnSpeed")}
        />
      );

    case PacingType.INSTRUCTORPACED:
      return (
        <IconDescription
          iconType="person"
          title={t("instructorLed")}
          subtitle={t("assignmentsHaveDueDates")}
        />
      );
  }
  return null;
}
